module.exports = __webpack_public_path__ + "img/tool-bar-logo.b57c9583.png";